import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ColorService {
    
    constructor() {}
    
    static parseRGBStr(str: string): Array<number>{        
        return str
            .replace(/[^0-9,]/g, '')
            .split(',')
            .map(c => parseInt(c));
    }
    
}
